/* ==========================
MINIMUM ORDER RULES
========================== */
const qtyState = {};
let lastVariantId = null;

let cartLocked = false;
const pendingVariants = [];

function getMinQty(level, brand){

 level=(level || "").toLowerCase().trim();
 brand=(brand || "").toLowerCase().trim();

 if(brand.includes('lost mary')){
   if(level.includes('hayati pro max+')) return 5;
   if(level.includes('lost mary bm6000')) return 5;
   if(level.includes('lost mary bm600')) return 10;
   if(level.includes('lost mary 20mg')) return 10;
   if(level.includes('lost mary 10mg')) return 10;
   if(level.includes('lost mary 5mg')) return 10;
   return 5;
 }

 if(brand.includes('ske')){
  //alert(level);
    if(level.includes('ske crystal bar 15k')) return 5;
    if(level.includes('ske crystal 30k pro max')) return 5;
    if(level.includes('ske cl6000')) return 5;
    if(level.includes('ske bar 6k kits')) return 5;
    if(level.includes('ske bar 6k pods')) return 5;
   /*if(level.includes('ske bar 600 pods')) return 10;
   if(level.includes('ske pro 600 kits')) return 10;
   if(level.includes('ske pro 600 pods')) return 10;
     if(level.includes('ske crystal plus')) return 10; 
  if(level.includes('ske cl2000')) return 10; */
   return 10;
 }

 if(brand.includes('elf bar')){
 // alert(level);
  if(level.includes('elf bar join one 15 classic')) return 5;
   if(level.includes('new compliant 600 puffs')) return 10;
   if(level.includes('elf bar')) return 10;
   if(level.includes('pre filled  pod systems')) return 10;
   if(level.includes('elfliq 20mg')) return 10;
   if(level.includes('elfliq 10mg')) return 10;
   if(level.includes('elfliq 5mg')) return 10;
   return 1;
 }

 if(level.includes('gold bar salts')){
   return 10;
 }
 if(brand.includes('riot squad bar') ||
    brand.includes('rito') ||
    brand.includes('drifter bar') ||
    brand.includes('yeti eliquid') ||
    brand.includes('just juice') ||
    brand.includes('bar series') ||
    brand.includes('lost vape') ||
    brand.includes('vampire vape') ||
    brand.includes('dinner lady') ||
    brand.includes('vgod') ||
    brand.includes('anarchist') ||
    brand.includes('flawless uk vape distribution ltd') ||
    brand.includes('ramillion') ||
    brand.includes('smok') ||
    brand.includes('slushie') ||
    brand.includes('fruza') ||
    brand.includes('zeus juice') ||
    brand.includes('donut king') ||
    brand.includes('ruthless e-juice') ||
    brand.includes('future juice') ||
    brand.includes('cuttwood') ||
    brand.includes('nasty juice') 
){
   return 10;
 }
 

 if(brand.includes('hayati') ||
  brand.includes('hyola') ||
  brand.includes('xygo') ||
  brand.includes('big bar') ||
  brand.includes('pyne pod') ||
  brand.includes('pixl') ||
  brand.includes('ivg') ||
  brand.includes('titan') ||
  brand.includes('vaporesso') ||
  brand.includes('bloody bar') ||
  brand.includes('juicy pod') ||
  brand.includes('vapes bars') ||
  brand.includes('al fakher') ||
  brand.includes('innokin') 
){
  if(level.includes('vaporesso dojoliq')) return 10;
  if(level.includes('vaporesso deliciu v2')) return 10;
  if(level.includes('vapes bars ghost')) return 10;
  if(level.includes('hayati pro max nic salt 20mg')) return 10;
   if(level.includes('hayati pro max nic salt 10mg')) return 10;
   if(level.includes('ivg intense')) return 10;
   if(level.includes('hayati finebar')) return 10;  
   if(level.includes('elf bar elfa pro')) return 10;
  if(level.includes('blu bar 20mg')) return 10;  
  if(level.includes('oxva slimstick')) return 10;
  if(level.includes('pixl salt 20mg')) return 10;
  if(level.includes('pixl salt 10mg')) return 10;
  if(level.includes('vaporesso xros 5')) return 1;
  if(level.includes('vaporesso xros 6')) return 1;
  return 5;
 }
  if(
    brand.includes('elux') 
  )
  {
    if(level.includes('elux legend 20mg')) return 10;
    if(level.includes('elux legend 10mg')) return 10;
    if(level.includes('elux legend 5mg')) return 10;
    if(level.includes('elux firerose')) return 10;
    
    return 5;
  }

 if(
   brand.includes('blu') 
 ){
   if(level.includes('pre filled pod systems')) return 10;
   if(level.includes('big puff devices')) return 5;
   if(level.includes('e liquids')) return 10;
   if(level.includes('blu bar 20mg')) return 6;
   return 1;
 }

 if(
   brand.includes('velo') ||
   brand.includes('clew') ||
   brand.includes('cuba') ||
   brand.includes('helwit') ||
   brand.includes('killa') ||
   brand.includes('neafs') ||
   brand.includes('nordic spirit') ||
   brand.includes('pablo') ||
   brand.includes('puff dragon') ||
   brand.includes('snü') ||
   brand.includes('snu') ||
   brand.includes('thor') ||
   brand.includes('ubbs') ||
   brand.includes('delia') ||
   brand.includes('terea') ||
   brand.includes('pixx') ||
   brand.includes('montreal original') ||
   brand.includes('crystal clear') ||
   brand.includes('doozy vape co') ||
   brand.includes('bar juice') ||
   brand.includes('oxva') ||
   brand.includes('pod salt') ||
   brand.includes('randm') ||
   brand.includes('pukka juice') ||
   brand.includes('mix labs') ||
   brand.includes('syx')

 ){
  if(level.includes('pablo 6mg')) return 5;
   return 10;
 }

 if(
   brand.includes('trip cbd') ||
   brand.includes('jaga')
 ){
   return 12;
 }


 if(level.includes('big puff devices')) return 5;
 if(level.includes('new compliant 600 puffs')) return 10;
 if(level.includes('e liquids')) return 10;
 if(level.includes('pre filled pod systems')) return 10;

 return 1;
}


function getLevel(wrapper){
 return wrapper.dataset.level2 || wrapper.dataset.level1 || "";
}



/* ==========================
MENU TOGGLES
========================== */

function toggleBrand(el){

 const panel=el.nextElementSibling;
 if(!panel || !panel.classList.contains('brand-products')) return;

 const isOpen=panel.style.display==="block";

 const group=el.parentElement;

 group.querySelectorAll(".brand-header").forEach(header=>{

   const p=header.nextElementSibling;

   if(header!==el){
      if(p) p.style.display="none";

      let a=header.querySelector(".arrow");
      if(a) a.style.transform="rotate(45deg)";
   }

 });

 panel.style.display=isOpen ? "none":"block";

 let arrow=el.querySelector(".arrow");

 if(arrow){
   arrow.style.transform=
      isOpen
      ? "rotate(45deg)"
      : "rotate(135deg)";
 }

}


function toggleSubmenu(el){

  const submenu = el.nextElementSibling;

  if(
    !submenu ||
    !submenu.classList.contains('submenu')
  ){
    return;
  }

  const opening =
    submenu.style.display !== 'block';

  submenu.style.display =
    opening ? 'block' : 'none';


  if(opening){

    const container =
      submenu.querySelector(':scope > .ajax-products');

    if(
      container &&
      container.dataset.loaded !== 'true'
    ){

      loadProducts(
        container.dataset.collection,
        container
      );

    }

  }

}

function loadProducts(collectionHandle, container){

 if(!collectionHandle) return;

 if(container.dataset.loaded === 'true'){
   return;
 }

 fetch('/collections/' + collectionHandle + '?view=shop-products')

 .then(response => response.text())

 .then(html => {

   container.innerHTML = html;

   container.dataset.loaded = 'true';
   container.style.display = 'block';
   updateStickyCart();   // <-- IMPORTANT

 })

 .catch(error => console.log(error));

}

/* ==========================
SEARCH
========================== */

function filterVendors(){

 const input=document.getElementById('vendor-search');
 if(!input) return;

 const filter=input.value.toLowerCase();

 const headers=document.querySelectorAll(".brand-header");
 const parents=document.querySelectorAll(".menu-parent");
 const allSubmenus=document.querySelectorAll(".submenu");

 parents.forEach(p=>p.style.display="none");
 allSubmenus.forEach(s=>s.style.display="none");

 headers.forEach(header=>{

   const txt=header.innerText.toLowerCase();

   if(txt.includes(filter)){

      header.style.display='';

      let parent=header.closest('.menu-parent');
      if(parent) parent.style.display='';

      let level2=header.closest('.submenu');
      if(level2) level2.style.display='block';

      let level1=parent.querySelector('.submenu');
      if(level1) level1.style.display='block';

   }else{
      header.style.display='none';
   }

 });

 if(filter.trim()===""){
   parents.forEach(p=>p.style.display='');
   headers.forEach(h=>h.style.display='');
   allSubmenus.forEach(s=>s.style.display='none');
 }

}



/* ==========================
STICKY CART
========================== */

function updateStickyCart(){

 fetch('/cart.js')
 .then(r=>r.json())
 .then(cart=>{

   const bar=document.getElementById("sticky-cart-bar");
   if(!bar) return;

   if(cart.item_count>0){
      bar.classList.remove("hidden");
   }else{
      bar.classList.add("hidden");
   }

   let qty=document.getElementById("cart-total-quantity");
   if(qty){
      qty.textContent=cart.item_count;
   }

   let sku=document.getElementById("cart-total-skus");
   if(sku){
      sku.textContent=cart.items.length;
   }

   let subtotalEl=document.getElementById("cart-subtotal");

   if(subtotalEl){
      subtotalEl.textContent=
         "£"+(cart.total_price/100).toFixed(2);
   }

   let subtotal=cart.total_price/100;
   let cashback=(subtotal*0.01).toFixed(2);

   document.querySelectorAll(
     '#cart-cashback-mobile .cashback-value'
   ).forEach(el=>{
      el.textContent="£"+cashback;
   });

   let shipping=document.querySelector(".shipping-txt");

   if(shipping){
      shipping.style.display=
       cart.total_price>30000
         ? "block"
         : "none";
   }


   /* reset all qty controls first */
   /*
   document.querySelectorAll('.qty-wrapper').forEach(wrapper=>{

      let addBtn=wrapper.querySelector('.add-btn');
      let box=wrapper.querySelector('.qty-box');
      let val=wrapper.querySelector('.qty-value');

      if(addBtn){
         addBtn.style.display='block';
      }

      if(box){
         box.classList.add('hidden');
      }

      if(val){
         val.textContent='1';
      }

   }); */
  

   /* sync actual cart */
   cart.items.forEach(item=>{

      let wrapper=document.querySelector(
       '.qty-wrapper[data-id="'+item.id+'"]'
      );

      if(wrapper){

        let addBtn=wrapper.querySelector('.add-btn');
        let box=wrapper.querySelector('.qty-box');
        let val=wrapper.querySelector('.qty-value');

         wrapper.dataset.incart = "true"; 

        if(addBtn){
          addBtn.style.display='none';
        }

        if(box){
          box.classList.remove('hidden');
        }

          if(val){

         const localQty = Number(wrapper.dataset.qty || 0);

        if( wrapper.dataset.loading === "true" &&
    Number(wrapper.dataset.qty) !== item.quantity){
            return;
        }

        wrapper.dataset.qty = item.quantity;
        val.textContent = item.quantity;

      }

      }

   });

 })
 .catch(err=>{
   console.log(err);
 });

}



/* ==========================
QTY BUTTONS
(event delegation)
========================== */

function initQtyButtons(){

document.addEventListener('click',function(e){

 let wrapper=e.target.closest('.qty-wrapper');
 if(!wrapper) return;

 let addBtn=wrapper.querySelector('.add-btn');
 let plus=wrapper.querySelector('.qty-plus');
 let minus=wrapper.querySelector('.qty-minus');
 let box=wrapper.querySelector('.qty-box');
 let value=wrapper.querySelector('.qty-value');

 //let qty=parseInt(value.textContent)||0;
 let qty = Number(wrapper.dataset.qty || value.textContent || 0);

 let step=getMinQty(
   getLevel(wrapper),
   wrapper.dataset.brand
 );

 let variantId=wrapper.dataset.id;



 if (e.target.classList.contains('add-btn')) {

    addBtn.style.display = "none";
    box.classList.remove("hidden");

    wrapper.dataset.qty = step;
    value.textContent = step;

      fetch('/cart/add.js',{
      method:'POST',
      headers:{
          'Content-Type':'application/json'
      },
      body:JSON.stringify({
          id:variantId,
          quantity:step
      })
  })
  .then(() => {

      wrapper.dataset.incart = "true";

      //updateStickyCart();


      clearTimeout(window.refreshTimer);

      window.refreshTimer = setTimeout(() => {
          updateStickyCart();
      }, 150);

  });

    return;
}


if (e.target.classList.contains('qty-plus')) {

    const currentQty = Number(wrapper.dataset.qty || value.textContent || 0);
    const newQty = currentQty + step;

    // Update UI instantly
    wrapper.dataset.qty = newQty;
    value.textContent = newQty;

    queueQtyUpdate(wrapper, variantId, newQty);

    return;
}





 if (e.target.classList.contains('qty-minus')) {

    const currentQty = Number(wrapper.dataset.qty || value.textContent || 0);

    let newQty = currentQty - step;

    if (newQty < 0) newQty = 0;

    wrapper.dataset.qty = newQty;
    value.textContent = newQty;

    if (newQty === 0) {
        box.classList.add('hidden');
        addBtn.style.display = 'block';
    }

    queueQtyUpdate(wrapper, variantId, newQty);

    return;
}

}); // closes document.addEventListener

} // closes initQtyButtons()



/* ==========================
FOOTER PUSH
========================== */

window.addEventListener(
 'scroll',
 function(){

 let footer=document.querySelector("footer");
 let bar=document.getElementById("sticky-cart-bar");

 if(!footer || !bar) return;

 let rect=footer.getBoundingClientRect();

 let mobile=window.innerWidth<=749;
 let bottom=mobile ? 60 : 20;

 if(rect.top<window.innerHeight){

   bar.style.bottom=
      (
        window.innerHeight
        - rect.top
        + bottom
      )+"px";

 }else{

   bar.style.bottom=
      bottom+"px";

 }

});



/* ==========================
LOAD
========================== */

document.addEventListener('DOMContentLoaded', async () => {

   let search=document.querySelector("#vendor-search");

   if(search){
      search.addEventListener(
        "input",
        filterVendors
      );
   }

   initQtyButtons();

    setTimeout(() => {

     updateStickyCart();

  },300);

 }
);

function queueQtyUpdate(wrapper, variantId, qty) {

    if (!qtyState[variantId]) {

        qtyState[variantId] = {
        wrapper: wrapper,
        sending: false,
        desiredQty: qty
    };

    } else {

        qtyState[variantId].wrapper = wrapper;
        qtyState[variantId].desiredQty = qty;

    }

   // processQtyQueue(wrapper, variantId);
      if (!pendingVariants.includes(variantId)) {
          pendingVariants.push(variantId);
      }

      processNextCartUpdate();



}


function processNextCartUpdate() {

    if (cartLocked) return;

    if (!pendingVariants.length) return;

    const variantId = pendingVariants.shift();

    const state = qtyState[variantId];

    if (!state) {
        processNextCartUpdate();
        return;
    }

    const wrapper = state.wrapper;
    const qty = state.desiredQty;

    cartLocked = true;

    // Only wait if switching to another variant
    const startRequest = () => {

    wrapper.dataset.loading = "true";

    fetch('/cart/change.js', {

        method: 'POST',

        headers: {
            'Content-Type': 'application/json'
        },

        body: JSON.stringify({

            id: variantId,

            quantity: qty

        })

    })

    .then(res => {

        if (!res.ok) {
            throw new Error("Cart update failed");
        }

        return res.json();

    })

    .then(() => {

        wrapper.dataset.loading = "false";

        //updateStickyCart();

        clearTimeout(window.refreshTimer);

          window.refreshTimer = setTimeout(() => {
              updateStickyCart();
          }, 150);

        // User clicked again while request was running
        if (state.desiredQty !== qty) {

            pendingVariants.push(variantId);

        }

    })

    .finally(() => {

        cartLocked = false;

        processNextCartUpdate();

    });
    };   // closes startRequest()

          // Only delay when changing to a different product
      if (lastVariantId && lastVariantId !== variantId) {

          lastVariantId = variantId;

          setTimeout(startRequest, 250);

      } else {

          lastVariantId = variantId;

          startRequest();

      }

}
